<script lang="ts">
import type { Component } from 'vue'

export interface SkeletonProps {
  as?: string | Component
  class?: string | object
}

const ui = {
  base: 'bg-secondary-200 animate-pulse rounded-sm',
}
</script>

<script setup lang="ts">
import { Primitive } from 'reka-ui'
import { useUnoMerge } from '../composables/useUnoMerge'

const props = defineProps<SkeletonProps>()

const primitiveClass = useUnoMerge(ui.base, typeof props.class === 'string' ? props.class : undefined)
</script>

<template>
  <Primitive
    :as
    aria-busy="true"
    aria-label="loading"
    aria-live="polite"
    role="alert"
    :class="primitiveClass"
  >
    <slot />
  </Primitive>
</template>
